var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    stroke: "black",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 3.90625H4.6875C4.25603 3.90625 3.90625 4.25603 3.90625 4.6875V20.3125C3.90625 20.744 4.25603 21.0938 4.6875 21.0938H20.3125C20.744 21.0938 21.0938 20.744 21.0938 20.3125V4.6875C21.0938 4.25603 20.744 3.90625 20.3125 3.90625Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 2.34375V5.46875",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 2.34375V5.46875",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 8.59375H21.0938",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98438 12.4996H11.7188L10.1563 14.4528C10.4132 14.4528 10.6661 14.5161 10.8927 14.6372C11.1193 14.7583 11.3125 14.9334 11.4553 15.147C11.5981 15.3606 11.686 15.6061 11.7112 15.8618C11.7364 16.1174 11.6982 16.3754 11.6 16.6128C11.5018 16.8502 11.3465 17.0597 11.148 17.2227C10.9494 17.3858 10.7137 17.4974 10.4618 17.5476C10.2098 17.5978 9.94937 17.5852 9.70348 17.5107C9.45759 17.4363 9.23385 17.3023 9.05207 17.1208",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 13.6716L15.625 12.4998V17.5779",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c0df39bac4d51a8e4a9758edd00dcef9.svg";
export { ForwardRef as ReactComponent };